require('./article.scss');
const  {newsletterCta} = require("../utils");

const loadLatestArticles = () => {
    let triggered = false;

    const triggerAction = () => {
        if (!triggered) {
            triggered = true;
            $(window).off('scroll', onScroll);

            $.ajax({
                url: '/wp-json/post/latest-articles',
                method: 'GET',
                data: {
                    post_id: $('#postId').data('post-id')
                },
                success: function (response) {
                    response.forEach((post, index) => {
                        index++;
                        $(`#article${index}Link`).attr('href', post.permalink);
                        $(`#article${index}TimeToRead`).text(post.time_to_read);
                        $(`#article${index}Category`).text(post.categories[0]?.name);
                        $(`#article${index}Title`).text(post.title);
                        $(`#article${index}Excerpt`).text(post.excerpt);
                        $(`#article${index}Thumbnail`).attr('src', post.thumbnail_url);
                        $(`#article${index}AuthorImage`).attr('src', post.author_image);
                        $(`#article${index}Name`).text(post.author_name);
                        $(`#article${index}ModifiedDate`).text(post.modified_date);
                    });
                },
            });
        }
    };

    const onScroll = () => {
        if ($(window).scrollTop() >= $(window).height()) {
            triggerAction();
        }
    };

    $(window).on('scroll', onScroll);
};


$(() => {
    newsletterCta('#newsletterSidebarForm', '#submitEmailCtaFormButton');
    loadLatestArticles();

    const tooltip = jQuery("#toolTipContent");
    const btn = jQuery("#toolTip");
    let timeoutId;

    function showTooltip() {
        tooltip.addClass("show");
        timeoutId = setTimeout(hideTooltip, 15000);
        let url = window.location.href;
        let el = jQuery('<textarea></textarea>');
        el.val(url);
        jQuery('body').append(el);
        el.select();
        document.execCommand('copy');
        el.remove();
    }

    function hideTooltip() {
        tooltip.removeClass("show");
    }

    function handleClick(event) {
        if (!tooltip.is(event.target) && event.target !== btn[0]) {
            hideTooltip();
        }
    }

    btn.on("click", showTooltip);
    jQuery(document).on("click", handleClick);

    $('#shareLinkButton').on('click', (e) => {
        navigator.clipboard.writeText(window.location.href);
    })


    $('#shareLinkButton').on('click', function () {
        const $this = $(this);

        $this.find('.original-text').addClass('d-none');
        $this.find('.copied-text').removeClass('d-none');

        setTimeout(() => {
            $this.find('.original-text').removeClass('d-none');
            $this.find('.copied-text').addClass('d-none');
        }, 3000);
    });

});


